import React, { useEffect, useState } from "react";
import { OUTBOUND_URL } from "../data/characters";
import { MessageCircle } from "lucide-react";

const FloatingCTA = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!show) return null;

  return (
    <a
      data-testid="floating-cta"
      href={OUTBOUND_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="floating-pulse fixed bottom-6 right-6 sm:bottom-8 sm:right-8 z-50 inline-flex items-center gap-3 bg-black text-white font-display font-black uppercase tracking-tight text-sm sm:text-base px-5 sm:px-6 py-3.5 sm:py-4 border-2 border-black"
      aria-label="Start chatting with AI characters"
    >
      <MessageCircle className="w-5 h-5 text-[#00E5FF]" />
      Start Chatting
    </a>
  );
};

export default FloatingCTA;
